import React from 'react';
import '../Components/ResiBan.css';
import { motion } from 'framer-motion';

export default function ResiBan() {
  return (
    <div className="resi-banner">
      <div className="container">
        <motion.div 
          className="resi-banner-content"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <h1>Residential <span>Construction</span></h1>
          <p>Building high-quality, luxury homes with precision and care in Madurai.</p>
        </motion.div>
      </div>
    </div>
  );
}
